module.exports = __webpack_public_path__ + "img/Romania GP1.c5f7cfe1.png";